export enum CONTEXT_MENU_EVENTS {
  VIEW = "View",
  EDIT = "Edit",
  DELETE = "Delete",
  UPDATE = "Update",
  RESET = "Reset",
  COPY = "Copy",
  COPY_URL = "Copy URL",
  DOWNLOAD = "Download",
  DETAILS = "Details",
  DEACTIVATE = "Deactivate",
  ACTIVATE = "Activate",
}
